import { FunctionComponent, useCallback, useEffect } from 'react'
import ReactDOM from 'react-dom'
import { useLocation } from 'react-router-dom'
import { Modal as HeroModal } from '@conexasaude/conexa-hero'
import { useModalContext } from './contexts/ModalContext'
import { ModalProps } from './types'

const Modal: FunctionComponent<ModalProps> = ({
  children,
  id,
  onDismiss,
  withCloseButton,
  ...rest
}) => {
  const { open, settings, closeModal } = useModalContext()

  const handleModalDismiss = useCallback(() => {
    closeModal()
    onDismiss && onDismiss()
  }, [closeModal, onDismiss])

  const location = useLocation()

  useEffect(() => {
    closeModal()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  if (open !== id) return null

  return ReactDOM.createPortal(
    <HeroModal
      {...rest}
      title={settings?.title ? settings?.title : ''}
      closeOnClickOutside={!settings?.persistent}
      size={settings?.width || 450}
      onClose={handleModalDismiss}
      opened
      withCloseButton={withCloseButton || !settings?.persistent}
    >
      {children}
    </HeroModal>,
    document.getElementById('hero-modal-root'),
  )
}

export default Modal
